export const multicodec = '/floodsub/1.0.0'
